import { gql } from 'graphql.macro';

export const CreateDepot = gql`
  mutation createDepot($request: DepotCollectionSaveRequestModelInput!) {
    createObservationDepot(request: $request)
  }
`;